import styled from 'styled-components'

const StripeErrorUi = styled.div`
  color: red;
  margin-top: 5px;
`

export default StripeErrorUi
